import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import TransactionSection from "../../Sections/Transaction";

const TransactionComponent = () => {
    return (
        <Dashboard
            sectionName={<TransactionSection />}
        />
    );
};

export default TransactionComponent;
